<template>
    <div class="col-md-12">
        <div class="">
            <div class="h2">Locations</div>
            <div class="">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <div @click="toggleModal"
                             class="btn btn-success float-right d-flex align-items-center"
                             title="Create booking">
                            <span class="material-icons-outlined cursor-pointer mr-1">post_add</span>
                            <span>Create Location</span>
                        </div>
                    </div>
                </div>
                <form @submit.prevent="deleteLocations">
                    <div class="position-relative pagination-control">
                        <data-table
                            :url="url"
                            :filters="filters"
                            :columns="columns"
                            :per-page="perPage"
                            :classes="classes"
                            :order-by="orderBy"
                            :order-dir="orderDir"
                            :meta="columns.meta"
                        >
                            <div slot="filters" slot-scope="{ tableFilters, perPage, locations }">
                                <div class="row my-3 d-flex justify-content-end align-items-center">
                                    <div class="col-md-3 additional-filters-">
                                        <label class="d-block mb-0 font-weight-bold">Select warehouse </label>
                                        <select required
                                                v-model="filters.warehouse"
                                                class="form-control">
                                            <option> All</option>
                                            <option v-for="warehouse in warehouses" :value="warehouse.id">
                                                {{ warehouse.nickname }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-3 additional-filters-">
                                        <label class="d-block mb-0 font-weight-bold"> Select type </label>
                                        <select
                                            v-model="filters.type"
                                            class="form-control">
                                            <option> All</option>
                                            <option value='10'>Transit</option>
                                            <option value='20'>Warehouse</option>
                                        </select>
                                    </div>

                                    <div class="col-md-3 additional-filters-">

                                    </div>

                                    <div class="col-md-3">
                                        <br/>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                                <span class="material-icons-outlined cursor-pointer">search</span>
                                            </button>
                                            <input name="name" v-model="filters.search"
                                                   class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                                   placeholder="Search"/>
                                        </div>
                                    </div>

                                </div>
                                <br/>
                            </div>
                            <thead class="clickable-header" slot="header" slot-scope="{ tableFilter }">
                            <tr>
                                <th>
                                    <!--                                    <input type="checkbox" v-model="allSelected" @change="selectAll($event)"/>-->
                                </th>
                                <th @click="sort(column.id)" v-if="column.label!==''"
                                    v-for="column in columns">
                                    <span> {{ column.label }} </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody slot="body" slot-scope="{ data }">
                            <tr
                                :key="location.id"
                                v-for="(location,key) in data">
                                <td
                                    :key="column.name"
                                    v-for="column in columns"
                                >
                                    <data-table-cell
                                        :value="location"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === ''">
                                        <input type="checkbox"
                                               v-model="locations[location.id]"
                                        >
                                    </slot>

                                    <slot v-if="column.label === 'Location'">
                                        {{ location.name }}
                                    </slot>

                                    <slot v-if="column.label === 'Warehouse'">
                                        {{ location.warehouse_data.nickname }}
                                    </slot>

                                    <slot v-if="column.label === 'Type'">
                                        {{ location.type === 10 ? 'Transit' : 'Warehouse' }}
                                    </slot>

                                    <slot v-if="column.label === 'Edit'">
                                        <a :href="`/locations/${location.id}/edit`" title="Edit Location">
                                            <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                                        </a>
                                    </slot>
                                </td>
                            </tr>
                            </tbody>
                        </data-table>
                    </div>
                    <br/>
                    <div class="d-flex justify-content-between">
                        <div>

                            <div
                                @click="exportLocations()"
                                class="btn btn-sm btn-success d-flex align-items-center float-left"
                                title="Export">
                                      <span class="material-icons-outlined cursor-pointer mr-1"
                                            title="export">post_add</span>
                                <span class="">Export</span>
                            </div>

                            <div
                                class="btn btn-sm btn-success d-flex align-items-center float-left import-location"
                                title="Import booking">
                                <input title="Import location" class="custom-file-input-" type="file"
                                       @change="importLocations" ref="file" name="file">
                            </div>

                            <div
                                @click="deleteLocations()"
                                class="btn  btn-sm btn-primary d-flex align-items-center float-left button-delete-location"
                                title="Delete booking">
                                      <span class="material-icons-outlined cursor-pointer mr-1"
                                            title="delete">delete</span>
                                <span class="">Delete</span>
                            </div>


                        </div>
                        <div class="">
                            <label class="pr-2">Locations per page:</label>
                            <div class="d-inline-flex center bg-white border rounded-lg div-focus border-2">
                                <select class="form-control bg-white border-0 py-0 shadow-none"
                                        v-model="filters.length"
                                        style="width: 150px;">
                                    <option
                                        :key="index"
                                        :value="records"
                                        v-for="(records, index) in perPage">
                                        {{ records }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add new location</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addNewLocation">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <input type="text"
                                           required
                                           autocomplete="none"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Name"
                                           v-model="newLocation.name"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select required
                                            v-model="newLocation.warehouse_id"
                                            class="form-control">
                                        <option v-for="warehouse in warehouses" :value="warehouse.id">
                                            {{ warehouse.nickname }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select required
                                            v-model="newLocation.type"
                                            class="form-control">
                                        <option value="10">Transit</option>
                                        <option value="20">Warehouse</option>
                                    </select>
                                </div>
                            </div>

                            <button class="btn btn-primary" @click="validation()">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

    </div>
</template>

<script type="text/ecmascript-6">
export default {
    name: "LocationDataTable",
    props: {
        url: {type: String, required: true},
    },
    data() {
        return {
            locations: [],
            currentLocations: [],
            orderBy: 'id',
            orderDir: 'desc',
            search: '',
            perPage: [100, 10, 25, 50],
            filters: {
                search: '',
                length: 100,
                column: 'id',
                dir: 'desc',
                type: '',
                warehouse: '',
            },
            loading: false,
            columns: [
                {
                    label: '',
                    id: '',
                    orderable: false,
                },
                {
                    label: 'Location',
                    id: 'name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Warehouse',
                    id: 'warehouse_id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                    searchable: true,
                },
                {
                    label: 'Edit',
                    id: 'edit',
                    orderable: false,
                },
            ],
            pagination: {
                align: "right",
                meta: {to: 1, from: 1}
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            selected: [],
            allSelected: false,
            activeModalInterval: false,
            show: false,
            isSubmit: false,
            newLocation: {},
            warehouses: {},
            fileName: '',
            attachment: '',
        }
    },
    methods: {
        fetchData() {
            axios.get('/warehouse-list')
                .then(({data}) => {
                    this.warehouses = data;
                }).catch();
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        validation() {
            this.isSubmit = true;
        },
        addNewLocation: function () {
            axios.post(`/locations`, this.newLocation).then((response) => {
                window.location.href = `/locations`;
            }).catch(err => {
                alert('failed to create new location')
            })
        },
        deleteLocations() {
            axios.post(`/delete-multiple-locations`, this.locations).then((response) => {
                window.location.href = `/locations`;
            }).catch(err => console.log(err))
        },
        exportLocations() {
            axios.post(`/locations/export`, this.locations).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'locations.csv');
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch(err => console.log(err))
        },
        importLocations(e) {
            this.formData = new FormData();
            this.formData.append('name', 'file');
            this.formData.append('file', e.target.files[0]);
            axios.post('/locations/import', this.formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                window.location.reload();
            }).catch(error => {
            });
        },
        async selectAll(event) {
            if (event.target.checked) {
                if (this.allSelected) {
                    Object.entries(this.currentLocations).forEach(entry => {
                        const [key, value] = entry;
                        this.locations[key] = true;
                    });
                }
            } else {
                this.locations = {};
            }
        }
    },
    created() {
        return this.fetchData()
    },
}
</script>

<style>
.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input::before {
    content: 'Choose file';
    display: inline-block;
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
}

.custom-file-input:hover::before {
    border-color: black;
}

.custom-file-input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.import-location {
    margin-left: 20px;
    margin-right: 20px;
}

.button-delete-location {
    background-color: red !important;
    border-color: red !important;
}

</style>
